module.exports = __webpack_public_path__ + "static/media/p14.3d7188f5.png";